import type { DashboardCoaching, Stage } from '@/core/types'
import { UPLOAD_ACCEPT } from '@/core/lib/fileTypes'
import { vertragReminderDisabledHint } from './flows/vertragReminder'

export const VERTRAG_REMINDER_ACTION = 'remind-vertrag'

export type AzavStage = 'avgs' | 'bewilligung' | 'vertrag' | 'nachweis' | 'abschluss' | 'abgeschlossen'

export type Column<S extends Stage = AzavStage> = {
  id: S
  dbName: string
  actionObject?: string
  actionVerb?: string
  actionIcon?: string
  clickable?: boolean
  headerAction?: string
  headerDroppable?: boolean
  headerAccept?: string
  headerBusyLabel?: string
  headerDisabledHint?: (rows: readonly DashboardCoaching[]) => string | null
  personAction?: string
  listOnly?: boolean
}

export const COLUMNS: Column<AzavStage>[] = [
  {
    id: 'avgs',
    dbName: 'Auf AVGS wartend',
    actionObject: 'Auf AVGS wartend',
    actionVerb: 'hochladen/reinziehen',
    actionIcon: 'i-upload',
    clickable: true,
    headerAction: 'upload-avgs',
    headerDroppable: true,
    headerAccept: UPLOAD_ACCEPT.join(','),
    headerBusyLabel: 'AVGS wird hochgeladen …',
    personAction: 'open-avgs',
  },
  {
    id: 'vertrag',
    dbName: 'Auf Vertrag wartend',
    actionObject: 'Erinnerung',
    actionVerb: 'an alle senden',
    actionIcon: 'i-send',
    clickable: true,
    headerAction: VERTRAG_REMINDER_ACTION,
    headerDisabledHint: (rows) => vertragReminderDisabledHint(rows),
    personAction: 'open-vertrag',
  },
  {
    id: 'bewilligung',
    dbName: 'Auf Bewilligung wartend',
    actionObject: 'Auf Bewilligung wartend',
    actionVerb: 'hochladen/reinziehen',
    actionIcon: 'i-upload',
    clickable: true,
    headerAction: 'upload-bewilligung',
    headerDroppable: true,
    headerAccept: UPLOAD_ACCEPT.join(','),
    headerBusyLabel: 'Bewilligung wird hochgeladen …',
    personAction: 'open-bewilligung',
  },
  {
    id: 'nachweis',
    dbName: 'Laufendes Coaching',
    actionObject: 'Coachingnachweis',
    actionVerb: 'ausfüllen',
    actionIcon: 'i-edit',
    clickable: true,
    headerAction: 'open-ecn',
    personAction: 'open-ecn',
  },
  {
    id: 'abschluss',
    dbName: 'Abschluss offen',
    actionObject: 'Abschlussbericht',
    actionVerb: 'ausfüllen',
    actionIcon: 'i-edit',
    clickable: true,
    personAction: 'open-abschluss',
  },
  {
    id: 'abgeschlossen',
    dbName: 'Abgeschlossen',
    clickable: true,
    personAction: 'open-personal',
  },
]

export function stageForStatusName(name: string | null | undefined): AzavStage | null {
  if (!name) return null
  return COLUMNS.find((c) => c.dbName === name)?.id ?? null
}

export function statusNameCandidatesFor(stage: Stage): string[] {
  const col = COLUMNS.find((c) => c.id === stage)
  return col ? [col.dbName] : [stage]
}
